<template>
  <hypto-popup :title="'Whitelist Remitters'" :footer="false">
    <template v-slot:body>
      <div class="wl-container" :class="{'show-items': remitters.length}">
        <div v-for="(data, index) in remitters" :key="index"
            class="wl-item">
          <div>
            <div class="row">
              <h5>Number</h5>:
              <p>{{data.number}}</p>
            </div>
            <div class="row">
              <h5>IFSC</h5>:
              <p>{{data.ifsc}}</p>
            </div>
          </div>
          <button @click="unwhitelistRemitter(data.id)">
            <i class="fa fa-times" />
            Delete
          </button>
        </div>
      </div>

      <bank-details class="bank" v-if="!add"
                    @updateAccount="updateAccount"
                    @setFunctions="setFunctions" />
      <error-info :errorList="formErrors.remitter" />

      <div class="options" v-if="remitters.length < maxLimit">
        <button class="primary-btn" v-if="add" @click="toggleOption">
          <i class="fa fa-plus" />
          Add
        </button>
        <button class="cancel dark-btn" v-if="!add" @click="toggleOption">
          <i class="fa fa-times" />
          Cancel
        </button>
        <button class="primary-btn" v-if="!add" @click="whitelistRemitter">
          <i class="fa fa-save" />
          Save
        </button>
      </div>

      <i class="info" v-if="remitters.length >= maxLimit">You have reached the maximum limit for whitelisting remitters. Please contact support to increase the limit.</i>
    </template>
  </hypto-popup>
</template>

<script>
import HyptoPopup from '@/components/global/HyptoPopup'
import ErrorInfo from '@/components/global/ErrorInfo'
import BankDetails from '@/components/Bank/InputDetails'

import { mapGetters, mapMutations } from 'vuex'
import { checkFormErrors } from '@/utils/helpers'
import ApiServices from '@/services/api/virtualAccounts'

export default {
  name: 'UpdateWhitelistRemitters',
  components: { HyptoPopup, BankDetails, ErrorInfo },
  data () {
    return {
      remitters: [],
      add: true,
      bankFunctions: null,
      number: null,
      ifsc: null,
      accountStatus: false,
      maxLimit: 5,
      formErrors: {
        remitter: [],
        number: [],
        ifsc: []
      }
    }
  },
  computed: {
    ...mapGetters(['getterSectionDetails'])
  },
  watch: {
    getterSectionDetails: {
      handler: 'populateData',
      immediate: true
    }
  },
  methods: {
    ...mapMutations(['SET_SECTION_DETAILS']),
    checkFormErrors,
    setFunctions (fun) {
      this.bankFunctions = fun()
    },
    populateData () {
      this.remitters = this.getterSectionDetails.va.whitelisted_remitters
      this.maxLimit = this.getterSectionDetails.wl_limit
    },
    toggleOption () {
      this.add = !this.add
      this.formErrors.remitter = []
    },
    unwhitelistRemitter (id) {
      ApiServices.unwhitelistRemitter({remitter_id: id}, this.$route.params.id).then(response => {
        this.handleResponse(response)
      }).catch(error => {
        this.formErrors = {
          ...this.formErrors,
          ...error.body.reason
        }
      })
    },
    whitelistRemitter () {
      this.bankFunctions.touchFields()
      if (this.accountStatus === 'SUCCESS' && !this.checkFormErrors(this.formErrors)) {
        const params = {
          number: this.number,
          ifsc: this.ifsc
        }

        ApiServices.whitelistRemitter(params, this.$route.params.id).then(response => {
          this.handleResponse(response)
        }).catch(error => {
          this.formErrors = {
            ...this.formErrors,
            ...error.body.reason
          }
          this.bankFunctions.setErrors(this.formErrors)
        })
      }
    },
    handleResponse (response) {
      if (response.success) {
        this.successToastMsg(response.message)
        this.SET_SECTION_DETAILS({
          ...this.getterSectionDetails,
          va: response.data.virtual_account
        })
        this.add = true
      } else {
        this.errorToastMsg(response.message)
      }
    },
    updateAccount (account, status) {
      this.number = account.number
      this.ifsc = account.ifsc
      this.accountStatus = status
      this.formErrors.remitter = []
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/mixins.scss';

  .options {
    width: 100%;
    text-align: right;
    margin-top: 10px;

    .cancel {
      margin-right: 5px;
    }
  }

  .bank {
    border: 2px solid $grey-outline !important;
    padding: 10px;
    margin-top: 8px;
    border-radius: 15px;
  }

  .info {
    color: $grey-light;
    display: block;
    text-align: left;
    font-size: 12px;
    margin-bottom: 5px;
  }

  .fa {
    margin-right: 5px;
  }

  .wl-container {
    &.show-items {
      border-radius: 15px;
      border: 2px solid $grey-outline !important;
      margin: 10px 0;
    }

    .wl-item {
      @include custom-flex(space-between);
      padding: 10px;
      border-bottom: 2px solid $grey-outline !important;

      button {
        border: 1px solid $grey-outline !important;
        border-radius: 5px;
        padding: 5px 8px;
        color: $error;
      }

      .row {
        @include custom-flex(flex-start);

        h5 {
          @include highlight-text($secondary, 14px);
          min-width: 60px;
          text-align: left;
        }
        p {
          @include normal-text();
          margin-left: 5px;
        }
      }

      &:last-child {
        border: none !important;
      }
    }
  }
</style>
